// extracted by mini-css-extract-plugin
export default {"ToolBox":"ToolBox_ToolBox__1f8jW","border":"ToolBox_border__BBDOR","Upload":"ToolBox_Upload__Kv018"};